import {FC, useMemo, MouseEventHandler, Button } from 'external/react'
import Icon from 'external/fortawesome'

type SelectUserButtonProps = {
    id: string
    type: 'tutor' | 'student'
    assigned: boolean
    assigning: boolean
    onClick: MouseEventHandler<HTMLButtonElement>
}

const SelectUserButton: FC<SelectUserButtonProps> = props => {

    const {id, type, assigning, assigned, onClick} = props

    const buttonIcon = useMemo(() => {
        if (assigning)
            return <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        const icon = type === 'student' ? (assigned ? 'faCheck' : 'faUser') : 'faUserTie'
        return <Icon name={icon} />
   }, [type, assigning, assigned, id])
   
   const disabled = useMemo(() => type == 'student' && assigned ? true : undefined, [type, assigned])

	return (
        <Button variant="outline-primary" size="sm" className="embedded-button-right" disabled={disabled} onClick={onClick}>
            {buttonIcon}
        </Button>
	)

}

export {SelectUserButton as default}